import http from '@/libs/AxiosPlugin'

const system = {
  get () {
    return http.get('/company/get')
    // return Promise.resolve({ id: 1, name: 'e-weaving', company: '心恬电子', address: '天河区思成路1号', contact: 'DaviaLi', phone: '13890039213', fax: '020-24434241', eMail: '22121@wewe.com', language: 'zh-cn', warnLimitTime: 300 })
  },

  save (info) {
    return http.post('/company/update', info)
  }
}

export default system



// WEBPACK FOOTER //
// ./src/api/system.js